import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function Countdown() {
  // Start with 23h 49m 56s in seconds
  const [timeLeft, setTimeLeft] = useState(23 * 3600 + 49 * 60 + 56);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center" data-id="element-63">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="bg-brand-card border border-brand-green/30 rounded-3xl p-8 md:p-12 relative overflow-hidden" data-id="element-64">
        <div className="absolute top-0 left-0 w-full h-1 bg-brand-darker" data-id="element-65">
          <div className="h-full bg-brand-green w-[68%]" data-id="element-66" />
        </div>

        <h2 className="text-2xl md:text-3xl font-black mb-8" data-id="element-67">
          ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
        </h2>

        <div className="flex justify-center items-center gap-4 md:gap-8 mb-8" data-id="element-68">
          <div className="flex flex-col items-center" data-id="element-69">
            <div className="bg-brand-darker border border-brand-green/20 rounded-xl w-20 h-24 md:w-28 md:h-32 flex items-center justify-center text-4xl md:text-6xl font-black text-brand-green shadow-[0_0_20px_rgba(168,85,247,0.1)]" data-id="element-70">
              {hours.toString().padStart(2, '0')}
            </div>
            <span className="text-gray-400 text-sm mt-3 font-medium uppercase tracking-wider" data-id="element-71">
              Horas
            </span>
          </div>
          <div className="text-3xl md:text-5xl font-black text-brand-green/50 pb-8" data-id="element-72">
            :
          </div>
          <div className="flex flex-col items-center" data-id="element-73">
            <div className="bg-brand-darker border border-brand-green/20 rounded-xl w-20 h-24 md:w-28 md:h-32 flex items-center justify-center text-4xl md:text-6xl font-black text-brand-green shadow-[0_0_20px_rgba(168,85,247,0.1)]" data-id="element-74">
              {minutes.toString().padStart(2, '0')}
            </div>
            <span className="text-gray-400 text-sm mt-3 font-medium uppercase tracking-wider" data-id="element-75">
              Min
            </span>
          </div>
          <div className="text-3xl md:text-5xl font-black text-brand-green/50 pb-8" data-id="element-76">
            :
          </div>
          <div className="flex flex-col items-center" data-id="element-77">
            <div className="bg-brand-darker border border-brand-green/20 rounded-xl w-20 h-24 md:w-28 md:h-32 flex items-center justify-center text-4xl md:text-6xl font-black text-brand-green shadow-[0_0_20px_rgba(168,85,247,0.1)]" data-id="element-78">
              {seconds.toString().padStart(2, '0')}
            </div>
            <span className="text-gray-400 text-sm mt-3 font-medium uppercase tracking-wider" data-id="element-79">
              Seg
            </span>
          </div>
        </div>

        <div className="inline-flex items-center gap-2 bg-red-500/10 text-red-400 px-4 py-2 rounded-full font-medium text-sm md:text-base mb-6" data-id="element-80">
          ⚠️ Después sube $5.000 ARS. No vuelve.
        </div>

        <div className="max-w-md mx-auto" data-id="element-81">
          <div className="flex justify-between text-sm font-bold text-gray-400 mb-2" data-id="element-82">
            <span data-id="element-83">Cupos tomados</span>
            <span className="text-brand-green" data-id="element-84">68%</span>
          </div>
          <div className="w-full bg-brand-darker rounded-full h-3 border border-brand-green/10" data-id="element-85">
            <div className="bg-brand-green h-full rounded-full w-[68%] shadow-[0_0_10px_rgba(168,85,247,0.5)]" data-id="element-86" />
          </div>
        </div>
      </motion.div>
    </section>;
}